module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-acw"
  }, [_c('a', {
    attrs: {
      "id": "a82"
    }
  }), _vm._v("Acknowledgements for Portraits and Maps")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Burne, Lieutenant Colonel A.H., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mesopotamia, the Last Phase")]), _vm._v(", Gale and Polden (nd)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Candler, Edward, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Long Road to Baghdad")]), _vm._v(", Vols I & II, Cassell (1919)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dunsterville, Major General L.C., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Adventures of Dunsterforce")]), _vm._v(", Edward Arnold (1920)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Marshall, William, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memories of Four Fronts")]), _vm._v(", Ernest Benn (1929)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Moberley, Brigadier General F.J., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Campaign in Mesopotamia 1914")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("–1918")]), _vm._v(", Official History, Stationery Office, Vol I, 1923, Vol II 1924")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Mousley, E.O., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secrets of a Kuttite")]), _vm._v(", Bodley Head (1922)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("One of its Officers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("With a Highland Regiment in Mesopotamia 1916")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("–1917")]), _vm._v(", The Times Press, Bombay (1918)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sherson, Erroll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Townshend of Chitral and Kut")]), _vm._v(", Heinemann (1928)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Staff College, Quetta, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Critical Study of the Campaign in Mesopotamia up to April 1917")]), _vm._v(", Government of India, Calcutta (1925)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Tennant, Lieutenant Colonel J.E., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In the Clouds above Baghdad")]), _vm._v(", Cecil Palmer (1920)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Wilson, Sir Arnold, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Loyalties")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("– Mesopotamia, 1914–1917")]), _vm._v(", OUP (1929)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018dd9e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Ack.vue
// module id = 72
// module chunks = 0